import React from 'react';
import '../style/Kyagu.scss';
// component
import Header from '../components/public/Header';
// React Bootstrap
import { Container, Row, Col, Image, Tab, Nav } from 'react-bootstrap';
// React redux
import { connect } from 'react-redux';
function Kyagu2({ lang }) {
  const k2 =
    'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fk02.png?alt=media&token=e2ddbeba-a709-4752-ab55-1b8b6ce4a44c';
  return (
    <>
      <Header />
      <Container className='kyagu'>
        <div className='kyaguBody pt-4 pr-5 pl-5'>
          <Row className='kyaguContent d-flex align-items-center justify-content-center'>
            <Col className='align-items-center'>
              {/* Header Image */}
              <Image src={k2} rounded fluid />
              {/* Title */}
              {lang === 'CH' ? (
                <h3 className='text-left text-secondary chinese mb-3 '>
                  帝師瑞巴 1164-1236
                </h3>
              ) : lang === 'TIB' ? (
                <h3 className='text-left text-secondary tibetan_Dutsa mb-3'>
                  བོད་ཡིག་
                </h3>
              ) : (
                <h3 className='text-left text-secondary mb-3'>English</h3>
              )}
            </Col>
          </Row>
          <Row>
            <Col>
              <Tab.Container id='left-tabs' defaultActiveKey='1'>
                <Row>
                  <Col sm={5} md={3}>
                    <Nav variant='pills' className='flex-column '>
                      {/* Tap 1 */}
                      <Nav.Item className='navItem'>
                        <Nav.Link eventKey='1'>
                          {lang === 'CH' ? (
                            <h4>自傳</h4>
                          ) : lang === 'TIB' ? (
                            <h4>རྣམ་ཐར།</h4>
                          ) : (
                            <h4>english</h4>
                          )}
                        </Nav.Link>
                      </Nav.Item>

                      {/* Tap 2 */}
                      <Nav.Item className='navItem'>
                        <Nav.Link eventKey='2'>
                          {lang === 'CH' ? (
                            <h4>大手印</h4>
                          ) : lang === 'TIB' ? (
                            <h4>ཕྱག་ཆེན། </h4>
                          ) : (
                            <h4>english</h4>
                          )}
                        </Nav.Link>
                      </Nav.Item>

                      {/* Tap 3 */}
                      <Nav.Item className='navItem'>
                        <Nav.Link eventKey='3'>
                          {lang === 'CH' ? (
                            <h4>那若六法</h4>
                          ) : lang === 'TIB' ? (
                            <h4>ཆོས་དྲུག </h4>
                          ) : (
                            <h4>english</h4>
                          )}
                        </Nav.Link>
                      </Nav.Item>

                      {/* Tap 4 */}
                      <Nav.Item className='navItem'>
                        <Nav.Link eventKey='4'>
                          {lang === 'CH' ? (
                            <h4>道歌</h4>
                          ) : lang === 'TIB' ? (
                            <h4>རྡོ་རྗེས་མགུར། </h4>
                          ) : (
                            <h4>english</h4>
                          )}
                        </Nav.Link>
                      </Nav.Item>

                      {/* Tap 5 */}
                      <Nav.Item className='navItem'>
                        <Nav.Link eventKey='5'>
                          {lang === 'CH' ? (
                            <h4>教言</h4>
                          ) : lang === 'TIB' ? (
                            <h4>ཞལ་གདམ། </h4>
                          ) : (
                            <h4>english</h4>
                          )}
                        </Nav.Link>
                      </Nav.Item>

                      {/* Tap 6 */}
                      <Nav.Item className='navItem'>
                        <Nav.Link eventKey='6'>
                          {lang === 'CH' ? (
                            <h4>儀軌</h4>
                          ) : lang === 'TIB' ? (
                            <h4>འདོན་ཆ།</h4>
                          ) : (
                            <h4>english</h4>
                          )}
                        </Nav.Link>
                      </Nav.Item>

                      {/* Tap 7 */}
                      <Nav.Item className='navItem'>
                        <Nav.Link eventKey='7'>
                          {lang === 'CH' ? (
                            <h4>法相</h4>
                          ) : lang === 'TIB' ? (
                            <h4>འདྲ་འབག </h4>
                          ) : (
                            <h4>english</h4>
                          )}
                        </Nav.Link>
                      </Nav.Item>

                      {/* Tap 8 */}
                      <Nav.Item className='navItem'>
                        <Nav.Link eventKey='8'>
                          {lang === 'CH' ? (
                            <h4>法帽</h4>
                          ) : lang === 'TIB' ? (
                            <h4>དབུ་ཞྭ། </h4>
                          ) : (
                            <h4>english</h4>
                          )}
                        </Nav.Link>
                      </Nav.Item>

                      {/* Tap 9 */}
                      <Nav.Item className='navItem'>
                        <Nav.Link eventKey='9'>
                          {lang === 'CH' ? (
                            <h4>佛寺</h4>
                          ) : lang === 'TIB' ? (
                            <h4>དགོན་པ།</h4>
                          ) : (
                            <h4>english</h4>
                          )}
                        </Nav.Link>
                      </Nav.Item>

                      {/* Tap 10 */}
                      <Nav.Item className='navItem'>
                        <Nav.Link eventKey='10'>
                          {lang === 'CH' ? (
                            <h4>閉關地</h4>
                          ) : lang === 'TIB' ? (
                            <h4>སྒྲུབ་གནས། </h4>
                          ) : (
                            <h4>english</h4>
                          )}
                        </Nav.Link>
                      </Nav.Item>

                      {/* Tap 11 */}
                      <Nav.Item className='navItem'>
                        <Nav.Link eventKey='11'>
                          {lang === 'CH' ? (
                            <h4>加持物</h4>
                          ) : lang === 'TIB' ? (
                            <h4>བྱིན་རླབས། </h4>
                          ) : (
                            <h4>english</h4>
                          )}
                        </Nav.Link>
                      </Nav.Item>

                      {/* Tap 12 */}
                      <Nav.Item className='navItem'>
                        <Nav.Link eventKey='12'>
                          {lang === 'CH' ? (
                            <h4>紀念法會</h4>
                          ) : lang === 'TIB' ? (
                            <h4>འདས་མཆོད། </h4>
                          ) : (
                            <h4>english</h4>
                          )}
                        </Nav.Link>
                      </Nav.Item>
                    </Nav>
                  </Col>

                  {/* Content */}
                  <Col sm={7} md={9}>
                    <Tab.Content className='tabContent'>
                      <Tab.Pane eventKey='1' className='tabPane'>
                        {lang === 'CH' ? (
                          <p className='chineseParagraph p-2'>
                            <h4 className='text-secondary chinese'>
                              众生怙主帝师慧狮子传
                            </h4>
                            帝师慧狮子木猴年（第二饶迥木猴年1164年）生于藏北牧区巴察地区四大雪钦（部落）之一的达雪那尔摩地方，霍尔族，姓董。董姓是四王八奴之中的当宗益仓官。
                            父亲名叫达尔查布，母亲为迦氏鲁杰。出生时，天降彩虹花雨，奇征妙相。父母亲非常高兴，设宴庆祝。根据苯教占卜师勒格帕尔哇贡札的卜算，以后成为一位众敬之人，如果出家习法将是一位高僧，取名霍尔扎。五岁开始就爱护小鸟和山羊，与众不同、七岁时，在同伴中经常做出说法和修行的样子，毫无恪惜地把自己的食物给别人吃。八岁，随阿阇黎旺僧学习藏文，同时掌握了算术和许多名言，求得修行教授后返回家中。十三岁，获悉上师宝巴荣巴的盛名，渴望见面，甚至激动得全身毛发抖动。当时上师宝巴荣巴住在绛孜瓦尔的达穷王城堡，被慧狮子父亲请到部落，恭敬承事，供献良马鞍雕和绫绢等财物。后来，巴荣巴去了多康，慧狮子没有随行。
                            十五岁那年，在蔡尔拜见了尚仁波且。遇到战争，指挥官要求他参加战斗。因此，他参加战争运送石炮（弹），投射沙石，最后取得胜利。仁波且说：“无论我怎样做，也离不了大手印。”不久，慧狮子受利加持，得到本心，敬献礼物，请求随持。
                            在举行战争胜利后的祭神活动时，巴荣巴传授了本尊生起次第法和四臂护法灌顶修行法。一次在藏顿舍布求教佛母灌顶时，巴荣巴通过智慧跃上天空，将自己撰写的究竟道教授，《五钉》和从贡茨传承的《达波耳传》、从爪译师传承下来的怙主法等全部授与慧狮子。
                            在叶尔巴谒见桑杰贡巴时，请求赐名，命名为“慧狮子。”同时，求得止贡木热巴耳传法、玛叶尔巴法王传承的法和道果独尊佛母夏玛法、息结派玛、索、甘三师传法、五次第法等。从欧雄巴弟子曼兰欧色受听欧氏传法续部灌顶教授，以及帐相等注释续、侍师五十颂等全部根本堕罪法。总之，慧狮子依止三位上师六年，学得全部教授。前去达隆，拜见了达隆塘巴仁波且，听讲大手印法和多哈，得到了帕木竹巴的全集，专心阅读。回到家乡后，静心温习和分析所学教授。有一天，突然听到止贡仁波且在纳木拉的拉玛岩洞传法，将众生引向异熟解脱道的消息，非常仰望，立即前去拜见，得到止贡仁波且的悲愍摄受，传授了五种大手印教授，及胜乐、金刚亥母灌顶。临别时，止贡仁波且对他说:“以后一定来止贡梯寺”，并赐道歌和良言。
                            后来，慧狮子来到巴荣，由阿阇黎旺僧作伴，于岩洞静修胜乐和四臂怙主法。一晚梦见上师尚仁波且身穿红色披风作金刚手法，对他说上师本尊无别。又有一天供修行下座时食子时，看见上师由千名黑怙主簇拥，对他说修事业法。获悉巴荣巴从康区返回的消息后，他急忙巴荣洞拜见献供，巴荣巴十分高兴，应请讲述了以前的历史。从此，慧狮子以巴荣巴为上师，住在巴荣求教亥母五本尊加持法。从十五日开始，巴荣巴讲授百字法；十八日授大手印教授；二十日观见大手印本性；二十四日修大手印法发挥效力；二十七日通达大手印，证悟更多的法，亲睹上师变成佛。
                            二十五岁，桑杰贡巴邀请巴荣巴到耶巴安穷地方，慧狮子随行。猴年四月十五日，释加牟尼觉悟日，从上师巴荣巴、桑杰贡巴、札茹巴顿巴扎、阿阇黎塔协达玛循努等受沙弥戒。并从轨范师札茹巴顿巴扎听讲《室罗摩尼罗迦梨迦》和《律经本论》。上师巴荣巴向全体僧人讲授了发菩提心、菩提道次第、甚深聚法等。同上师一起回到巴荣，上师仁波且巴荣巴往雪贡寺，他作为近侍弟子求教那若六法、四法和上师自己撰写的《十三明要法》等。之后一段时间，象大仙一样云游拉隆、杂隆、宇垄、杂德邬、穷雪浦、顿雪木、勒格娘等地方，修炼解脱双运道，证达等引和后得二智无别，并出现了气心无二之成就相。
                            当时，慧狮子对上师巴荣巴产生了比佛更虔诚的信仰，一刻也不愿离开，止贡仁波且从绛纳木拉来到巴荣，他求教冈波达波拉杰亲自讲授的聚法教授，进行了贴心交谈。俟后，巴荣巴和止贡仁波且二人来到巴荣滩的一个红色盘石上，设法座接受僧俗部众的侍奉。一晚巴荣巴登上法座讲授发菩提心法，另一晚由止贡仁波且讲授五种大手印教授，使在座的人成熟了大菩提因。从此止贡仁波且去了丹萨梯寺，上师巴荣巴回到寺院。
                            慧狮子回到祖父跟前，稍待了一段时间，温习善恶因果业之分辨、大悲观音修行法和大手印法。回想起止贡仁波且以前说的话，前往止贡梯，一见止贡梯寺急忙放下背包叩拜，亲眼目睹六十二尊胜乐本尊。在这里，谒见了觉巴仁觉巴，敬献礼品，听讲觉巴仁波且自己的教授法和有关四续部的曼荼罗天众灌顶、教授、随许法、资粮法等。一天傍晚，到仁波且跟前，敬献七支供、曼荼罗等，汇报从善知识听法的感受。上师巴荣巴说：“什么也不要说，稍坐。”他作了“殊胜菩提心宝”愿颂。
                            第二天早晨，在走廊做善行时，上师仁波且来到那里来回度步，嘴里不停地说：“大尸体，大尸体。”当时，那里只有我一人，不知道上师是说给谁听的。又一天，上师突然问：’你的证悟从何产生的?”我回答：“是从我的导师巴荣巴的恩惠。”上师听了十分高兴。有时，上师从佛法的内外秘三方面讲述法王止贡仁波且的事迹。
                            卯年(兔年)六月初四日佛转法轮日，慧狮子三十二岁时，从轨范师塔玛贝钦、亲教师古拉哇、屏教师达循等二十位比丘僧受近圆戒，并从轨范师塔玛贝钦听讲《别解脱戒经》、《律经广释》及《集学论》，驻锡止贡寺一年。回到上师巴荣巴跟前，广做祈祷感戴。上师仁波且去蔡贡塘寺后，他随去汇报证悟感受，向僧徒介绍修法情况，并校正审订过去所学教授，补修尚未学完之法。后去叶尔巴寺，谒见桑贡，学习噶当派的全部教法。从此去达隆晋谒塘巴仁波且，听讲菩提心法及其它聚法。达隆塘巴法王说：“中部有莲花大地，你留住这里。”他感谢祈祷，告别塘巴仁波且，经过故乡直接到巴荣，向上师献曼荼罗请安。上师仁波且说：“现在尚好。”并教导说：“以前，你依止多位善知识，精进修行，得到圆满，现在需要护持资粮或掌管寺院，必须选择一样你喜欢的。”“我没有护持资粮(护众)的想法，希望云游山间小寺修行。” 巴荣巴说：“不断佛的世系是护教，不思众生唯修他利，如果这样，必须学习前辈的传记(事迹)。”一天，出现了一位身着披肩，头戴高毡帽，名叫色香的老人。我问他：“你从什么地方来的?”“从多麦来的，是与荼商结伴来的。”之后再未有提问。那人说西夏国王驾崩后，法王执政，他福气大，供养几位卫藏地区的喇嘛。慧狮子听后萌发了去多麦的念头，晚上没有梦境。次日，他将去多麦和西夏的想法告诉巴荣巴，请求赐教。上师巴荣巴说：“我们父子在一起虽然很开心，但是你希望走，去东方也有你的徒众。”准备好行装后，他来到上师跟前请求加持和藏跋拉修行法。上师说：“不需要求教。”赐给一件宝盔和礼物。并说：“藏跋拉修行法你自己有”，接着又赠送了许多礼品。临走时，授与一顶五尖绢帽，象征五位有恩上师，即亲自介绍心性如意宝是喇嘛巴荣仁波且之恩，传授绕天空之见是喇嘛尚仁波且之恩，引导通达密法是喇嘛桑杰贡巴仁波且之恩，通达缘起法是喇嘛止贡仁波且之恩，感戴不断是达隆塘巴之恩，五尖绢帽象征有五位根本上师。
                            慧狮子前后在巴荣习法七年，兔年八月十七日，和几位朋友结伴前往东方多麦，上师仁波且师徒送行。临别前他问上师“我何时回来?”上师说：“你自己知道，”祝愿吉祥幸福。他们一行顺北道行抵达曼鲁图，在朋友绛扎店住了三个月。在这里，慧狮子目睹忿怒明王马头金刚显现，是解除路途障碍之因缘。行抵丹隆滩，出现了一个不好的因缘，返回到夏布多。晚上，梦见一位骑着银鬃褐马的黄色人身着金甲，头戴金帽，上面插着一根鸟羽，右手拿旗，左手拿猫鼬，嘴里说我的宫殿在东方。慧狮子以为是玛沁雪山，实际上不是，而是多闻子之授记。走到越钦(地名)住了数日，一天晚上吉祥天女热玛底很威严地驾临，授记说：“你的徒众在咱米国，无论如何也要去西夏。”另有土地神迎接。行抵宗喀的哲绒寺，受到阿阇黎雅隆巴僧格坚参和格德邬色巴两人的接待。从此来到凉州(兰州？)，国王获悉后，派来金书使臣迎接到水木汇聚地松贡寺讲经。
                            三十五岁，创建了瓜曲格茹寺；在巴底谒觐国王，创建了色噶寺。另外建了喀尔隆拉钦寺、宗喀郭拉寺、绛萨寺等。那些时候，大家看见真传上师本尊空行众在天空密云中，诵吉祥词，奏响长腰北鼓鼓，降下虹光花雨。僧众发展到万余人。
                            后来，请到噶卡尔王宫，承事供养，和格西藏巴哇一起诵经修法，使国王的病痊愈。王塔呼退位后，将位传给王子嘉果。有一段时间，蒙古兵包围了噶卡尔宫，洪水冲毁了墙。在这危机关头，为了退兵，慧狮子做怙主施食仪式，投抛之时，看见清凉寒林中四臂怙主由其他几位怙主陪同直接去了对面的蒙古兵方向，洪水倒流冲毁了蒙古兵营，蒙古兵大败，噶卡尔因此没有受到侵害。嘉果王非常虔诚信仰，请求灌顶。封慧狮子为“帝师。”“帝师”在藏语中是为国王头顶灌顶的上师。献了水晶巴荣像，琉璃写的经卷。
                            以后，慧狮子为在西夏国的汉藏上师善知识、僧众、国王、王妃、众臣及其它男女信徒讲授皈依法、八种别解脱律、菩提心法，祈祷灌顶，播洒解脱道教授等解脱的种子。为使施主们福运昌盛，将他们所献各种礼品布施各寺僧人，制造金瓶，刻写十万续部和经典多函，雕塑金银佛像，供奉各大寺院。另外，示现各种奇异神通。《传记颂》说：“佛像经典佛塔殿，身语意所依无数，授权举行开光时，忿怒本尊发呼声。或有瓶水自沸腾，或有树木长莲花，或有佛塔发巨光，或有鲜花自动开，或有贪恋园中花。清净国士法行地，不同民族八种语，君臣庶民上千万，保护生命行正法。众人敬仰之法王，引导众生仁波且，获得授记敬颂你。”
                            当时，北方居西纳地界有座专门供养饮光佛(伽叶佛)的孜尔卡庙宇已经破损不堪，慧狮子筹措物资对内外进行维修，并举行了盛大的落成开光仪式。翻修新建如此破旧的庙宇，作为情器世间天人信仰的基地，真是不可思议。
                            在噶卡尔静修期间，护国王毗沙门骑马逃跑，到了很远的地方，白天印由恶毒的有形头覆盖天空，张嘴向着东面，出现在噶卡尔城(宫)。对此，慧狮子大发慈悲心，立本尊胜乐像，众生到本尊口中，本尊闭口，天王从外面逃跑了。
                            总之，从铁猴年到木鸡年的二十六年里，慧狮子在西夏说法讲经，举行各种退敌活动，保护西夏。六十三岁那年，拒绝西夏君臣的挽留回藏。途经夏尔欧德热等地方时，受到居士僧俄旺雅的迎接。驻锡德雪娘地期间，观见天空各种珠宝做成的无量宫中央端坐着金刚瑜伽母，面带笑容，讲授甚深方便解脱教授，直到他掌握后，金刚瑜伽母融进其身。这时，慧狮子全身燃起无法忍受的快乐之火，心中的秘密法性难以叙说，证得俱生智。
                            从此顺北道回到巴荣，仪仗队迎接，见过温仁波且，向僧人讲法。止贡和达隆之争被调解后，他先后到蔡贡塘和叶尔巴等寺院献供，和这两座寺院的僧人建立法缘。回到巴荣寺，为佛堂开光，供奉佛像，为僧众授教后，再次去了康区。在巴乃盖滩遇见噶举派诸位上师，授四教法，撰写甚深道论著。以后在噶托尔浦、惹巴尔贡、惹甘等地分别目睹毗沙门、怙主、观世音。在达尼嘉，看见阿底峡，身边靠着两位着瑜伽服的妃子，说：“我的声闻十八部主，这个给你，你拿着”。(以后得法承修部十八部的授记)在觉达纳摩切支帐居住期间，他对阿阇黎窘布、轨范师热章哇、荣噶轨范师、贡巴哇等多位僧人说：“搭帐蓬，看见边上有城墙环绕了吗?”对侍从喜饶多杰说：“这里将会有佛殿和修行者，对众生很有利。我这样说，岩脚下出现泉水，得到文字。”慧狮子还对身前人员说：“这里建大寺院，先建佛的修行处，次建大经堂，最后是盗匪的藏身所。”弟子们问他“能住多长时间?”住不长一段时间。”他说：“以前我没有参与调解尚仁波且之争，以后那里会出现虎狼争斗。因此，最后寺院僧人分成两派，会毁灭寺院。”当地地主名叫杂旺巴，他年龄稍高，缠着一条绢巾，向慧狮子求法。慧狮子向杂嘉、恰浦顿纳、包罗洛等讲法。驻锡期间，为弟子们讲授了多种法。他说：“我的灯油将尽，或象池塘水源枯竭，多种无常法和我所有的全部传给你们。”由于当时，慧狮子感到身体不适，闭关修行，身体日渐昏重，到了需要离开的时侯。弟子们请求留下。他说：“如果对他们有利，即使身体不好，也要走。”调解纠纷后，他来到郭佐寺，僧众念诵般若广中略三品事奉，即使这样，身体仍未见好。莅居巴荣修行洞后，又举行七支供(敬礼支、供养支、忏悔支、随喜支、请转法轮支、请住世支和回向支)活动。他向在寺的僧俗弟子、男女信徒授教。俟后，弟子们支起帐蓬做佛事祈祷。猴年五月初一日，星星在东方山顶升起手指高时，慧狮子的色身摄入曼荼罗，遗体用轿子抬着到澜沧江边由于水势凶猛船筏无法渡过，做心无生女之祈祷，澜沧江(又达楚)江水刹时下降，载放遗体的船筏顺利过江。当晚来到迈尔曲边，到处充满光。初四日，在迈尔钦火化遗体，当时大家看见飘烟中慧狮子仁波且头戴五尖帽在天空飞翔，彩光满布，花雨飘落，奇相不断。向一万余名比丘僧、信徒及阿阇黎、
                            官员、众弟子布施财物，向摩揭陀大菩提塔和圣地树送去供品。
                            遗体火化后出现了不少舍利，其中心、舌、眼舍利供胜乐本尊父母像和观世音像，经卷、五色舍利装塔，另有右旋螺舍利等。
                            众生怙主慧狮子有汉藏、西夏弟子无数，难以一一介绍。其中主要弟子有：京俄热巴噶尔波、轨范师格尔噶哇、萨班家族的桑窘哇(萨班侄子)、地方官轨范师热章哇、轨范师喜饶尼玛、吉雪巴、芒贡热巴、喜饶多杰、格西窘波、绒喀堪布、轨范师觉赛、札吾旺秋、贝曲贡木巴、比丘扎巴益希、蒙古帕巴、轨范师觉等。
                          </p>
                        ) : lang === 'TIB' ? (
                          <p>
                            <h1>བོད་ཡིག་</h1>
                          </p>
                        ) : (
                          <p>
                            <h1>English</h1>
                          </p>
                        )}
                      </Tab.Pane>
                      <Tab.Pane eventKey='second' className='tabPane'>
                        <p>i am Singapore</p>
                      </Tab.Pane>
                      <Tab.Pane eventKey='third' className='tabPane'>
                        <p>i am tibet</p>
                      </Tab.Pane>
                      <Tab.Pane eventKey='forth' className='tabPane'>
                        <p>i am tibet</p>
                      </Tab.Pane>
                    </Tab.Content>
                  </Col>
                </Row>
              </Tab.Container>
            </Col>
          </Row>
        </div>
      </Container>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    lang: state.lang.lang,
  };
};

export default connect(mapStateToProps)(Kyagu2);
